<template>
  <div class="spo-card pa-2 rounded my-2" v-if="option.visible_accueil == '1'">
    <v-row>
      <v-col>
        <div class="text-h6 font-weight-bold">{{ option.nom }}</div>
        <LiaisonsOptions v-if="option_has_liaisons" :option="option"></LiaisonsOptions>



        <div v-if="option.information_supplementaire != ''">
          <div class="text-body-1" v-html="option.information_supplementaire"></div>
        </div>
        <div v-if="$moment(option.date_min).isValid()">Ouverture des inscriptions: {{ $moment(option.date_min + " " +
          option.heure_min).format("DD/MM/YYYY à HH:mm") }}</div>
        <div v-if="$moment(option.date_max).isValid()">Fermeture des inscriptions: {{ $moment(option.date_max + " " +
          option.heure_max).format("DD/MM/YYYY à HH:mm") }}</div>

        <div class="text-body-2" v-for="variante in variantes_tarifs" :key="variante.id">
          <span v-if="variante.information_variante_tarif != ''">- {{ variante.information_variante_tarif }} ({{
            variante.prix }}€)</span>
          <!-- <span v-if="variante.quantite == '0'">{{ variante.nb_inscrits }} participant(s)</span> -->
          <span v-else-if="variante.quantite != '0' && parseInt(variante.quantite) > parseInt(variante.nb_inscrits)"> :
            {{
              variante.nb_inscrits }}/{{ variante.quantite }} participant(s)</span>
          <span v-else-if="variante.quantite != '0' && parseInt(variante.quantite) <= parseInt(variante.nb_inscrits)"> :
            Complet</span>
        </div>
      </v-col>

      <v-col cols="12" lg="3" xl="2">
        <div v-if="mainStore.billetterie_mode">
          <SportipsButton v-if="show_button_inscription" @onClick="$router.push({ name: 'Inscriptions' })"
            icon="mdi-pencil-plus-outline" chevron action-button full-width>Réserver</SportipsButton>
          <div v-else
            class="d-flex align-center justify-center ga-1 bg-dark-red text-white rounded py-2 px-1 font-weight-600 cursor-disabled">
            <v-icon icon="mdi-pencil-off-outline"></v-icon>
            Inscriptions closes
          </div>
        </div>
        <div v-if="!mainStore.billetterie_mode && option.has_bouton_renvoi_billetterie()">
          <SportipsButton v-if="show_button_inscription" @onClick="redirect_to_billetterie()"
            icon="mdi-pencil-plus-outline" chevron action-button full-width>Réserver seule
          </SportipsButton>
          <div v-else
            class="d-flex align-center justify-center ga-1 bg-dark-red text-white rounded py-2 px-1 font-weight-500 cursor-disabled">
            <v-icon icon="mdi-pencil-off-outline"></v-icon>
            Inscriptions closes
          </div>
        </div>
        <TarifsOption :base="option.prix" :metadatas="option.metadatas"></TarifsOption>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import LiaisonsOptions from "@/components/Home/Options/LiaisonsOptions.vue";
import TarifsOption from "@/components/Home/Options/Tarifs_Option.vue";
export default {
  props: ["option", "all_options"],
  components: { TarifsOption, LiaisonsOptions },
  computed: {
    ...mapStores(useMainStore),
    show_button_inscription() {
      const selectionnable = this.option.is_selectionnable(this.mainStore.module.status, this.mainStore.view_as_admin, this.mainStore.inscription_as_admin, this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe)
      return selectionnable;
    },
    option_has_liaisons() {
      return this.option.has_liaisons();
    },
    variantes_tarifs() {
      let variantes = [];
      for (let i = 0; i < this.all_options.length; i++) {
        if (this.all_options[i].nom == this.option.nom) {
          variantes.push(this.all_options[i]);
        }
      }
      return variantes;
    },
  },
  methods: {
    redirect_to_billetterie() {

      this.mainStore.billetterie_mode = true;
      this.$router.push({ name: "Inscriptions", params: { base_module: "BILLETTERIE_" + this.mainStore.module.base } });
    }
  },
};
</script>

<style lang="scss" scoped></style>